import styled from "styled-components";

export const ModeButton = styled.button`
  ${({ $active, theme: { colors } }) => `
    background: ${$active ? colors("highlight", 0.2) : colors("chrome")};
    color: ${$active ? colors("highlight") : colors("highlight", 0.55)};
    border: 1px solid ${$active ? colors("highlight", 0.55) : colors("foreground", 0.15)};
    padding: 0.45rem 0.75rem;
    font-family: 'Silkscreen', monospace;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 0.65rem;
    touch-action: manipulation;
    &:hover { background: ${colors("highlight", 0.2)}; color: ${colors("highlight")}; }
  `}
`;

export const SidebarLabel = styled.div`
  color: ${({ theme: { colors } }) => colors("highlight", 0.55)};
  font-size: 0.6rem;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
`;
